<template>
    <div class="results-list" :aria-busy="isFetching">
        <div class="results" :key="formateur.id" v-for="formateur in PaginationCond">
            <hgroup v-if="formateur.Etablissement">
                <span>{{formateur.Etablissement}}</span>
                <h3>{{formateur.Prenom}} {{formateur.Nom}}</h3>
            </hgroup>
            <hgroup v-else>
                <h3>{{formateur.Prenom}} {{formateur.Nom}}</h3>
            </hgroup>

            
            <p class="petite_majuscule">
              <span v-if="formateur.Adresse_ligne1">{{formateur.Adresse_ligne1}} {{formateur.Ville}}  {{formateur.Code_postal}}<br></span>
              <span v-if="formateur.Adresse_ligne2">{{formateur.Adresse_ligne2}}<br></span>
              <span v-if="formateur.Telephone">Tél. : {{formateur.Telephone}}<br></span><span v-if="formateur.Telephone2">{{formateur.Telephone2}}<br></span>
              <span v-if="formateur.Courriel"><a v-bind:href="'mailto:'+formateur.Courriel">{{formateur.Courriel}}</a></span><br>
              <span v-if="formateur.SiteWeb"><a v-bind:href="formateur.SiteWeb">Site web</a></span>
            </p>

            <div v-if="formateur.Region_desservies">
              <p class="small"><strong>Régions :</strong> {{formateur.Region_desservies}}</p>
            </div>
            <div v-if="formateur.Type_de_formations_offertes">
              <p class="small"><strong>Formations :</strong> {{formateur.Type_de_formations_offertes}}</p>
            </div>
            <div v-if="formateur.Langues_de_formation">
              <p class="small"><strong>Langues :</strong> {{formateur.Langues_de_formation}}</p>
            </div>
            <p class="small" v-if="formateur.IndicateurOffertEnLigne=='TRUE'"><strong>Formation disponible en ligne</strong> : Oui</p>
            <p class="small" v-else><strong>Formation disponible en ligne</strong> : Non</p>
            <div v-if="formateur.Modifie">
              <p class="small"><em>Dernière mise à jour : {{formateur.Modifie}}</em></p>
            </div>
            
        </div>
    </div>
</template>

<script>

export default {
    name: 'Condamnations',
    props: {
      nbrResultats: {
        type: Number
      },
      isFetching:{
        type:Boolean
      },
      formateurs: {
        type: Array
      },
      pageCourante: {
        type: Number
      },
  },
    computed: {
      PaginationCond () {
        return  this.formateurs.slice((this.pageCourante - 1) * this.nbrResultats, this.pageCourante * this.nbrResultats )
      }
    }
}
</script>
